package article.neumorphism

import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateIntAsState
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.BlurredEdgeTreatment
import androidx.compose.ui.draw.blur
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Outline
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex


const val NEUMORPHISM_SAMPLE = "0c11bb556a1bfe44f153e1b65d15eb75286abe00ca05a091387441cd390b0c50"

val gray100 = Color(0xffe5e5e5)
val gray200 = Color(0xffd0d0d0)



@Composable
fun NeumorphismSample() {
    Box(
        Modifier
            .fillMaxSize()
            .background(Color(0xffe5e5e5))
    ) {


        Box {

            Box(
                Modifier
                    .zIndex(10f)
                    .graphicsLayer {
                        shape = object : Shape {
                            override fun createOutline(
                                size: Size,
                                layoutDirection: LayoutDirection,
                                density: Density
                            ): Outline {
                                 return Outline.Rectangle(
                                    Rect(
                                        offset = Offset.Zero,
                                        size = Size(size.width / 2, size.height)
                                    )
                                )
                            }

                        }
                        clip = true
                    }
//                    .weight(1f)
                    .background(gray100)
                    .fillMaxSize(),
                contentAlignment = Alignment.Center
            ) {

                Box(
                    Modifier
                        .aspectRatio(1f)
                        .align(Alignment.Center)
                        .fillMaxWidth()
                        .padding(64.dp)

                ) {

                    var pressed by remember { mutableStateOf(false) }


                    val offset by animateIntAsState(targetValue = if (pressed) 5 else 30)
                    val blur by animateDpAsState(targetValue = if (pressed) 4.dp else 10.dp)

                    Box(
                        Modifier
                            .fillMaxSize()
                            .offset { IntOffset(0, -offset) }
                            .blur(blur, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                            .background(Color.White, CircleShape)
                    )

                    Box(
                        Modifier
                            .fillMaxSize()
                            .offset { IntOffset(0, offset) }
                            .blur(blur, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                            .background(Color.Black.copy(alpha = .2f), CircleShape)
                    )

                    Box(
                        Modifier
                            .fillMaxSize()
                            .background(
                                Brush.verticalGradient(
                                    colors = listOf(
                                        gray100,
                                        gray200,
                                    )
                                ),
                                CircleShape
                            )
                            .pointerInput(Unit) {
                                detectTapGestures(
                                    onPress = {
                                        pressed = true
                                        awaitRelease()
                                        pressed = false
                                    }
                                ) {}
                            }
                            .pointerHoverIcon(PointerIcon.Hand)
                            .border(
                                width = 1.dp,
                                shape = CircleShape,
                                brush = Brush.verticalGradient(
                                    colors = listOf(
                                        Color.White,
                                        Color.Black.copy(alpha = .15f),
                                    )
                                )
                            )
                    )
                }
            }








            Box(
                Modifier
//                    .weight(1f)
                    .background(Color(0xff212121))
                    .fillMaxSize(),
                contentAlignment = Alignment.Center
            ) {

                Box(
                    Modifier
                        .aspectRatio(1f)
                        .align(Alignment.Center)
                        .fillMaxWidth()
                        .padding(64.dp)

                ) {

                    Box(
                        Modifier
                            .fillMaxSize()
                            .offset { IntOffset(0, -20) }
                            .blur(20.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                            .background(Color.White.copy(alpha = .1f), CircleShape)
                    )

                    Box(
                        Modifier
                            .fillMaxSize()
                            .offset { IntOffset(0, 20) }
                            .blur(20.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                            .background(Color.Black.copy(alpha = .9f), CircleShape)
                    )

                    Box(
                        Modifier
                            .fillMaxSize()
                            .background(
                                Brush.verticalGradient(
                                    colors = listOf(
                                        Color(0xff212121),
                                        Color(0xff1f1f1f),
                                    )
                                ),
                                CircleShape
                            )
                            .border(
                                width = 1.dp,
                                shape = CircleShape,
                                brush = Brush.verticalGradient(
                                    colors = listOf(
                                        Color.White.copy(alpha = .15f),
                                        Color.Black.copy(alpha = .2f),
                                    )
                                )
                            )
                    )

                }

            }

//            Box(
//                Modifier.weight(1f).fillMaxWidth(),
//                contentAlignment = Alignment.Center
//            ) {
//
//            }

        }

        return

        val red500 = Color(0xffe32b31)
        val red600 = Color(0xffbf262b)
        Box(
            Modifier
                .fillMaxSize()
                .background(
                    color = red500
                ),
            contentAlignment = Alignment.Center,
        ) {
            Box(
                Modifier
                    .padding(128.dp)
                    .aspectRatio(1f)
                    .fillMaxHeight()
            ) {

                Box(
                    Modifier
                        .fillMaxSize()
                        .offset { IntOffset(0, -20) }
                        .blur(10.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                        .background(
                            color = Color.White.copy(alpha = .1f),
                            shape = HeartShape
                        )
                )

                Box(
                    Modifier
                        .fillMaxSize()
                        .offset { IntOffset(0, 40) }
                        .scale(1.1f)
                        .blur(15.dp, edgeTreatment = BlurredEdgeTreatment.Unbounded)
                        .background(
                            color = Color.Black.copy(alpha = .1f),
                            shape = HeartShape
                        )
                )

                Box(
                    Modifier
                        .fillMaxSize()
                        .border(
                            Dp.Hairline,
                            brush = Brush.verticalGradient(
                                colors = listOf(
                                    Color.White.copy(alpha = .4f),
                                    Color.Black.copy(alpha = .1f),
                                )
                            ),
                            shape = HeartShape
                        )
                        .background(
                            brush = Brush.verticalGradient(
                                colors = listOf(
                                    red500,
                                    red600,
                                )
                            ),
                            shape = HeartShape
                        )
                )

            }
        }

    }
}

val HeartShape = HeartShapeImpl()

class HeartShapeImpl : Shape {
    override fun createOutline(
        size: Size,
        layoutDirection: LayoutDirection,
        density: Density
    ): Outline {
        val path = Path()

        path.addArc(
            Rect(
                offset = Offset(0f, 0f),
                Size(size.width / 2, size.width / 2)
            ),
            startAngleDegrees = -180f,
            sweepAngleDegrees = 180f,
        )
        path.addArc(
            Rect(
                offset = Offset(size.width / 2, 0f),
                Size(size.width / 2, size.width / 2)
            ),
            startAngleDegrees = -180f,
            sweepAngleDegrees = 180f,
        )
        path.moveTo(0f, size.height / 4)
        path.quadraticBezierTo(0f, size.height / 2, size.width / 2, size.height)
        path.quadraticBezierTo(size.width, size.height / 2, size.width, size.height / 4)

        return Outline.Generic(path)
    }

}